module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch5",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "12",
      "id": "pg_12",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("Understanding Patterns")])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Besides the pattern shape, there is a variety of other information on the pattern pieces. This brief guide will help you understand what the terms mean and what they are for.")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img100",
    attrs: {
      "alt": "",
      "src": "images/pg12.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', {
    staticClass: "TIPH"
  }, [_c('samp', {
    staticClass: "SANS_Tiva_Heavy"
  }, [_vm._v("Language skills …")])]), _vm._v(" "), _c('p', {
    staticClass: "TIP-TEXT"
  }, [_c('samp', {
    staticClass: "SANS_Tiva_Regular_17"
  }, [_vm._v("You’ll quickly become familiar with sewing terms and abbreviations. Keep referring back to these pages until you become confident.")])])]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('span', {
    attrs: {
      "aria-label": "13",
      "id": "pg_13",
      "role": "doc-pagebreak"
    }
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Seam allowance")]), _vm._v(" – this is the distance between the edge of the fabric piece(s) and the sewing machine needle. So, if a pattern indicates that the seam allowance is 1cm ("), _c('span', {
    staticClass: "fraction-3-8-"
  }, [_vm._v("⅜")]), _vm._v("in), you need to sew your stitches 1cm ("), _c('span', {
    staticClass: "fraction-3-8-"
  }, [_vm._v("⅜")]), _vm._v("in) in from the edge of the fabric. The pattern instructions should always state the seam allowance size and whether or not it has been included in the pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Grain lines")]), _vm._v(" – these are the two pointed arrows that help you to align the pattern piece with the straight grain of the fabric. The top arrow points to the top edge of the fabric and the bottom arrow points to the bottom edge of the fabric. The straight grain of the fabric runs parallel to the selvedge (the non-fraying edge of the fabric, which often has the company and fabric name printed on it).")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Fold lines")]), _vm._v(" – when a pattern piece says ‘place on fold’ you need to fold your fabric wrong sides together and place the edge of the pattern piece onto the fabric fold. In this way, the resulting cut fabric piece will be double the size.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Notches")]), _vm._v(" – these are the lines that appear on the pattern piece outline. These useful markings help you to match up seams and fabric edges accurately. Pattern pieces that need joining up will have corresponding notches. Transfer pattern notches to your fabric pieces using a disappearing marker or make small nicks with sharp scissors.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Other pattern markings")]), _vm._v(" – magnetic snap/handle loop/zip pocket/Velcro markings etc. need to be traced onto your patterns and then transferred to your fabric pieces.")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1-NOTOP"
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("Glossary of terms and abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("In addition to the patterns, you will also need to be able to follow the written instructions for each technique or project. The following terms are used throughout this book and in other commercial patterns.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Bag lining/bag exterior")]), _vm._v(" – most bags have a lining and an exterior, which essentially means that most bags consist of two bags (the inside bag and the outside bag). Each bag is made separately before being joined together towards the end of construction. In this book I refer to the inside bag as the ‘lining bag’ and the outside bag as the ‘exterior bag’.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Clip")]), _vm._v(" – clipping your seam allowance helps seams lie flat when you turn your project right side out by reducing bulk in the seams (especially curved seams). For inward curves cut small V-shapes pointing towards the stitching along the seam allowance close, but not too close, to the stitching. For outward curves make small scissor nicks pointing towards the stitching (again, not too close to the stitching).")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Clip corners")]), _vm._v(" – snipping off the seam allowance reduces bulk in the seams of straight corners and makes for smoother and sharper corners on your bag when it is turned right side out. This results in neater rectangular pockets or fabric straps, for example. Before turning right side out, trim off the corner tips of your work close, but not too close, to the stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Raw edges")]), _vm._v(" – refers to the cut, unstitched and unfinished edges of fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Sewing in a box formation")]), _vm._v(" – particularly useful for stitching strap ends down securely onto your work. Stitch the item in a box shape for extra strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Topstitching")]), _vm._v(" – a line of stitches that runs close and parallel to an edge on the right side of your work. The distance between the stitches and the edge will vary according to your preference or the instructions in the project. Topstitching is very useful in that it often serves both decorative and reinforcing functions.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Turning right side out (sometimes abbreviated – TRSO)")]), _vm._v(" – simply means that you need to turn your (inside out) work the right way out. "), _c('b', [_vm._v("Turning wrong side out")]), _vm._v(" means the reverse of the above.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("WS")]), _vm._v(" – wrong side – the reverse or back of your work or fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("WST")]), _vm._v(" – wrong sides together – bring two pieces of fabric together so that the wrong sides of the fabrics are touching each other.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("WSO")]), _vm._v(" – wrong side out – the wrong side of your work/fabric is facing outwards.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("WSU")]), _vm._v(" – wrong side up – the wrong side of your work/fabric is facing upwards.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("RS")]), _vm._v(" – right side – the good or the front side of your fabric or work.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("RST")]), _vm._v(" – as WST, but with the right sides.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("RSO")]), _vm._v(" – as WSO, but with the right side.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT"
  }, [_c('img', {
    staticClass: "bl",
    attrs: {
      "alt": "",
      "src": "images/icon.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("RSU")]), _vm._v(" – as WSU, but with the right side.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57722966","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 78
// module chunks = 0